import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { AdminRoutingModule } from './admin-routing.module'; 
import { AdminPageComponent } from './components/page/admin-page.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ListingsSearchIndexService } from './services/listings-search-index.service';
import { ParsingService } from './services/parsing.service';

@NgModule({
  declarations: [
	AdminPageComponent,
  ],
  providers: [
    ListingsSearchIndexService,
    ParsingService
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    MatGridListModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    SharedModule
  ],
})
export class AdminModule { }
